module.exports = "<div class=\"text-center\">\n    <img src=\"assets/img/loading/loading.gif\" > \n</div> "


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/loading_component/loading.component.html
// module id = ./src/app/component/shared/loading_component/loading.component.html
// module chunks = main